import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { GENERAL_ENQUIRY_URL } from '../../utils/whatsapp';
export function Header() {
  return <header className="sticky top-0 z-40 bg-navy" data-id="element-5" data-mp="10rto3iha6lek">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-3.5 sm:px-8" data-id="element-6" data-mp="1epqmmkfap1vv">
        <a href="#inicio" className="font-brand text-2xl italic tracking-tight text-ivory sm:text-3xl" aria-label="Jam Fragrances, inicio" data-id="element-7" data-mp="19q5o2b41evjo">
          Jam Fragrances
          <span className="text-lime" data-id="element-8" data-mp="i099jkdzgdk5">.</span>
        </a>

        <nav aria-label="Navegación principal" className="flex items-center gap-4 sm:gap-6" data-id="element-9" data-mp="vqmf5g3ejg6b">
          <a href="#perfumes" className="text-xs font-semibold uppercase tracking-wide text-ivory/80 transition-colors duration-200 ease-smooth hover:text-lime" data-id="element-10" data-mp="vsh558tj5yh9">
            Perfumes
          </a>
          <a href={GENERAL_ENQUIRY_URL} target="_blank" rel="noreferrer" className="flex items-center gap-2 rounded-full bg-lime px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-navy transition-colors duration-200 ease-smooth hover:bg-lime-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-11" data-mp="3uheiecikood3">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-12" data-mp="lkbeiuy4dhbe" />
            Pedir por WhatsApp
          </a>
        </nav>
      </div>
    </header>;
}